<template>
    <div class="page-container" style="scroll-behavior: smooth;">
        <div>
            <b-modal id="my-modal" centered hide-footer :no-close-on-backdrop="true" title="Cookie policy">
                <p class="text-modal">Diese Website verwendet Cookies und Analysewerkzeuge. Wir gehen davon aus, dass dies für Sie in Ordnung ist, aber Sie können die Verwendung von Cookies jederzeit ablehnen, wenn Sie dies wünschen. Hiernach wird jedoch die Nutzung der Webseite verwehrt.</p>
                <p class="text-modal">Sie können Ihre Einstellungen für Google Analytics und Cookies auf Seite Datenschutz aktualisieren.</p>
                <b-button class="mt-3" variant="success" block @click="acceptCookies">Akzeptieren</b-button>
            </b-modal>
        </div>

        <div class="row">
            <div class="">
                <div class="">
                    <img class="w-100" src="../assets/mobilemain.png">
                </div>
                <b-row>
                    <h1 class="entry-tittle-main px-2">Wie viel kostet eine App? </h1>
                </b-row>
                <b-row>
                    <p class="entry-text-cc text-white pt-4 pb-4 px-3 text-justify">Wir werden immer öfters gefragt, wieviel es kostet, eine App zu erstellen. Wie Sie richtig vermuten, hängt dies von vielen unterschiedlichen Faktoren ab. Dieser App-Rechner soll Ihnen eine Preisvorstellung vermitteln.Die tatsächlichen Preise können jedoch nach unten bzw. nach oben variieren. Viel Spaß beim ersten Schritt zu Ihrer eigenen App.</p>

                </b-row>
                <b-row class="entry-part-end">
                    <b-button href="#cost" class="cc-button text-center mx-auto">Preis herausfinden</b-button>
                </b-row>
            </div>

        </div>
        <b-row class="mb-5 text-center">
            <b-col cols="4"> <b-button @click="$router.push('/'), step1()" class="route-mobile">Schritt 1</b-button></b-col>
            <b-col cols="4"> <b-button @click="$router.push('/schritt2')" class="route-mobile">Schritt 2</b-button></b-col>
            <b-col cols="4"> <b-button @click="$router.push('/schritt3')" class="route-mobile">Schritt 3</b-button></b-col>
        </b-row>
                <router-view />
        <div id="schritt-3">
            <div class="page-paddings">
                <!--final count-->
                <div class=" mt-5" >
                    <b-row class="marketing-component p-5">
                        <h3 class="text-white marketing-component-text">Hat Ihnen unser APP-Rechner gefallen? Folgen Sie uns auf LinkedIn!  </h3>
                        <b-button target="_blank" href="https://www.linkedin.com/company/north-it-group" class="cc-button text-center mx-auto mt-3">Jetzt Posts liken </b-button>
                    </b-row>
                </div>

                <div class="mt-5" >
                    <b-row class="marketing-component p-5" style="text-transform: uppercase">
                        <h3 class="text-white marketing-component-text">Hinterlassen Sie uns Ihre E-Mail und wir senden Ihnen kostenlos</h3>
                        <h3 class="cc-point-title-last marketing-component-text">  unseren App Guide </h3>

                        <b-row class="w-100">

                            <v-row>
                                <v-col cols="12" class="fill-height">
                                    <v-form @submit.prevent="submit" >
                                        <v-card tile flat :loading="loading" color="transparent">
                                            <v-card-text>
                                                <v-row>
                                                    <v-col cols="12" class="pa-0 ma-0">
                                                        <p class="p-0">Vorname</p>
                                                        <v-text-field
                                                                class="pa-0 ma-0"
                                                                solo
                                                                type="text"
                                                                v-model="form.name"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="pa-0 ma-0">
                                                        <p class="p-0">Nachname</p>
                                                        <v-text-field
                                                                class="pa-0 ma-0"
                                                                solo
                                                                type="text"
                                                                v-model="form.surname"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" class="pa-0 ma-0">
                                                        <p class="p-0">Email</p>
                                                        <v-text-field
                                                                class="pa-0 ma-0"
                                                                solo
                                                                type="text"
                                                                v-model="form.email"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer/>
                                                <v-btn type="submit" class="button cc-button">App Guide bekommen</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-form>
                                </v-col>

                            </v-row>

<!--                            <div id="mc_embed_signup" class="w-100">-->
<!--                                <form action="https://northitgroup.us10.list-manage.com/subscribe/post?u=b88b7f682ba8315a4c9b316d5&amp;id=cd6c3d8bb0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>-->
<!--                                    <div id="mc_embed_signup_scroll" class="text-white w-100">-->


<!--                                        <div class="mc-field-group">-->
<!--                                            <label for="mce-EMAIL">Email  <span class="asterisk">*</span>-->
<!--                                            </label>-->
<!--                                            <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">-->
<!--                                        </div>-->
<!--                                        <div class="mc-field-group">-->
<!--                                            <label for="mce-LNAME">Vorname </label>-->
<!--                                            <input type="text" value="" name="LNAME" class="" id="mce-LNAME">-->
<!--                                        </div>-->
<!--                                        <div class="mc-field-group">-->
<!--                                            <label for="mce-FNAME">Name </label>-->
<!--                                            <input type="text" value="" name="FNAME" class="" id="mce-FNAME">-->
<!--                                        </div>-->

<!--                                        <div id="mce-responses" class="clear">-->
<!--                                            <div class="response" id="mce-error-response" style="display:none"></div>-->
<!--                                            <div class="response" id="mce-success-response" style="display:none"></div>-->
<!--                                        </div>-->
<!--                                        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_b88b7f682ba8315a4c9b316d5_cd6c3d8bb0" tabindex="-1" value=""></div>-->
<!--                                        <div class="clear mt-5"><input type="submit" value="App Guide bekommen" name="subscribe" id="mc-embedded-subscribe" class="button cc-button"></div>-->
<!--                                    </div>-->
<!--                                </form>-->
<!--                            </div>-->
                            <!--End mc_embed_signup-->
                        </b-row>
                    </b-row>
                </div>
            </div>
            <b-row class="site-footer">
                <b-col cols="12" class="text-center">
                    <p>Entwickelt von </p><a href="https://northitgroup.com/" target="_blank"><p class="drop-highlighter pl-1 pr-1"> North IT Group GmbH | Unsere Webseite  </p></a>
                </b-col>
                <b-col class="col-6"><p class="text-right pt-3 pr-4"><router-link to="/Impressum">Impressum</router-link></p></b-col>
                <b-col class="col-6"><p class="text-left pt-3 pl-4"><router-link to="/Datenschutz">Datenschutz</router-link></p></b-col>
            </b-row>
        </div>
    </div>


</template>

<script>

    export default {
        components: {

        },
        data() {
            return {
                form: {
                    name: null,
                    surname: null,
                    email: null

                },
                Cost2: '',
                text1: '',
                text2: '',
                formatter: '',
                // total1: 0,
                total2: 0,
                total3: 0,
                value: 0,
                selected1: '',
                selected2: '',
                selected3: '',
                selectedB2B: '',
                selectedB2C: '',
                selected5: '',
                selected6: '',
                selected7: '',
                selected8: '',
                selected9: '',
                selected10: '',
                selected11: '',
                selected12: '',
                selected13: '',
                selected14: '',
                selected15: '',
                result1: '',
                options1: [
                    { item: 'A', name: 'Nativ' },
                    { item: 'B', name: 'Hybrid' },
                    { item: 'C', name: 'Web-App' },
                    { item: 'D', name: 'Mobile Webseite' },
                ],
                options2: [
                    { item: 'A', name: 'Ja', },
                    { item: 'B', name: 'Nein', }
                ],
                options3: [
                    { item: 'A', name: 'Eigene Mitarbeiter' },
                    { item: 'B', name: 'B2B' },
                    { item: 'C', name: 'B2C' }
                ],
                optionsB2B: [
                    { item: 'A', comment: '<p class="b-hover" data-id>Customer Relationship Manager <span data-comment class="comment-info">info</span></p>' },
                    { item: 'B', comment: '<p class="b-hover" data-id>Employee Education <span data-comment class="comment-info">info</span></p>' },
                    { item: 'C', comment: '<p class="b-hover" data-id>Customer Education <span data-comment class="comment-info">info</span></p>' },
                    { item: 'D', comment: '<p class="b-hover" data-id>Finance Manager <span data-comment class="comment-info">info</span></p>' },
                    { item: 'E', comment: '<p class="b-hover" data-id>Task Manager <span data-comment class="comment-info">info</span></p>' },
                    { item: 'F', comment: '<p class="b-hover" data-id>Messenger <span data-comment class="comment-info">info</span></p>' },
                    { item: 'H', comment: '<p class="b-hover" data-id>Unternehmenskommunikation <span data-comment class="comment-info">info</span></p>' },
                    { item: 'J', comment: '<p class="b-hover" data-id>Conference App <span data-comment class="comment-info">info</span></p>' },
                    { item: 'K', comment: '<p class="b-hover" data-id>Notizen <span data-comment class="comment-info">info</span></p>' },
                    { item: 'O', comment: '<p class="b-hover" data-id>E-Mail-Anwendung <span data-comment class="comment-info">info</span></p>' },
                    { item: 'M', comment: '<p class="b-hover" data-id>Scanner <span data-comment class="comment-info">info</span></p>' },
                    { item: 'N', comment: '<p class="b-hover" data-id>News-gathering service <span data-comment class="comment-info">info</span></p>' },
                    { item: 'S', comment: '<p class="b-hover" data-id>Remote access service <span data-comment class="comment-info">info</span></p>' },
                    { item: 'T', comment: '<p class="b-hover" data-id>Designer App <span data-comment class="comment-info">info</span></p>' },
                    { item: 'R', comment: '<p class="b-hover" data-id>Reservation App <span data-comment class="comment-info">info</span></p>' },
                    { item: 'Z', comment: '<p class="b-hover" data-id>Security<span data-comment class="comment-info">info</span></p>' },
                    { item: 'X', comment: '<p class="b-hover" data-id>Online Shop <span data-comment class="comment-info">info</span></p>' },
                    { item: 'Y', comment: '<p class="b-hover" data-id>Andere <span data-comment class="comment-info">info</span></p>' }
                ],
                optionsB2C: [
                    { item: 'A', comment: '<p class="b-hover" data-id>Spiele <span data-comment class="comment-info">Abenteuer, Action, Arcade, Brettspiele, Gelegenheitsspiele, Kartenspiele, Kasino, Lernspiele, Musik, Puzzles, Rennsport, Rollenspiele, Simulation, Sportspiele, Strategie, Quizspiele, Worträtsel</span></p>' },
                    { item: 'B', comment: '<p class="b-hover" data-id>Kunst & Design <span data-comment class="comment-info">Zeichenblöcke, Zeichenbedarf, Zubehör für Kunst & Design, Malbücher</span></p>' },
                    { item: 'C', comment: '<p class="b-hover" data-id>Autos & Fahrzeuge <span data-comment class="comment-info">Autokauf, Autoversicherung, Preisvergleich von Autos, Fahrsicherheit, Autobewertungen und -Neuigkeiten</span></p>' },
                    { item: 'D', comment: '<p class="b-hover" data-id>Schönheitspflege <span data-comment class="comment-info">Make-Up-Anleitungen, Styling-Tools, Frisuren, Schönheitsprodukte, Make-Up-Simulatoren</span></p>' },
                    { item: 'E', comment: '<p class="b-hover" data-id>Bücher & Nachschlagewerke <span data-comment class="comment-info">E-Book-Reader, Nachschlagewerke, Textbücher, Wörterbücher, Thesauren, Wikis</span></p>' },
                    { item: 'F', comment: '<p class="b-hover" data-id>Büro <span data-comment class="comment-info">Bearbeiten und Lesen von Dokumenten, Paketverfolgung, Remote Desktop, E-Mail-Verwaltung, Stellensuche</span></p>' },
                    { item: 'H', comment: '<p class="b-hover" data-id>Comics <span data-comment class="comment-info">Comic-Player, Comic-Titel</span></p>' },
                    { item: 'J', comment: '<p class="b-hover" data-id>Kommunikation <span data-comment class="comment-info">SMS/MMS, Chat/IM, Telefonanwendungen, Adressbücher, Browser, Anrufverwaltung</span></p>' },
                    { item: 'K', comment: '<p class="b-hover" data-id>Verabredung <span data-comment class="comment-info">Partnerzuordnung, Kennenlernen, Beziehungen aufbauen, neue Leute kennenlernen, die große Liebe finden</span></p>' },
                    { item: 'O', comment: '<p class="b-hover" data-id>Bildung <span data-comment class="comment-info">Prüfungsvorbereitung, Lernhilfen, Vokabeln, Lernspiele, Sprachtrainer</span></p>' },
                    { item: 'M', comment: '<p class="b-hover" data-id>Unterhaltung <span data-comment class="comment-info">Videos streamen, Filme, Serien, interaktive Unterhaltung</span></p>' },
                    { item: 'N', comment: '<p class="b-hover" data-id>Events <span data-comment class="comment-info">Konzerttickets, Eintrittskarten für Sportveranstaltungen, Weiterverkäufe von Tickets und Kinokarten</span></p>' },
                    { item: 'S', comment: '<p class="b-hover" data-id>Finanzen <span data-comment class="comment-info">Bankgeschäfte, Bezahlung, Geldautomatensuche, Finanznachrichten, Versicherungen, Steuern, Aktienhandel, Trinkgeldrechner</span></p>' },
                    { item: 'T', comment: '<p class="b-hover" data-id>Essen & Trinken <span data-comment class="comment-info">Rezepte, Restaurants, Essenstipps, Wein entdecken & probieren, Getränkerezepte</span></p>' },
                    { item: 'R', comment: '<p class="b-hover" data-id>Gesundheit & Fitness <span data-comment class="comment-info">Persönliche Fitness, Verfolgen von Workout-Erfolgen, Diät- und Ernährungstipps, Gesundheit und Sicherheit</span></p>' },
                    { item: 'Z', comment: '<p class="b-hover" data-id>Haus & Heim <span data-comment class="comment-info">Haus- und Wohnungssuche, Renovierungen, Dekoration, Hypotheken, Immobilien</span></p>' },
                    { item: 'X', comment: '<p class="b-hover" data-id>Software & Demos <span data-comment class="comment-info">Software-Bibliotheken, technische Demos</span></p>' },
                    { item: 'Y', comment: '<p class="b-hover" data-id>Lifestyle <span data-comment class="comment-info">Stilratgeber, Hochzeits- und Partyplanung, Anleitungen</span></p>' },
                    { item: 'W', comment: '<p class="b-hover" data-id>Karten & Navigation <span data-comment class="comment-info">Navigationstools, GPS, Karten, Transittools, öffentliche Verkehrsmittel</span></p>' },
                    { item: 'V', comment: '<p class="b-hover" data-id>Medizin <span data-comment class="comment-info">Arzneimittelverzeichnisse und klinische Nachschlagewerke, Rechner, Handbücher für Gesundheitsdienstleister, medizinische Fachzeitschriften und Nachrichten</span></p>' },
                    { item: 'I', comment: '<p class="b-hover" data-id>Musik & Audio <span data-comment class="comment-info">Musikdienste, Radios, Musikplayer</span></p>' },
                    { item: 'P', comment: '<p class="b-hover" data-id>Nachrichten & Magazine <span data-comment class="comment-info">Zeitungen, Nachrichtenaggregatoren, Zeitschriften, Blogs</span></p>' },
                    { item: 'U', comment: '<p class="b-hover" data-id>Eltern <span data-comment class="comment-info">Schwangerschaft, Säuglingspflege- und Überwachung, Kinderbetreuung</span></p>' },
                    { item: 'S', comment: '<p class="b-hover" data-id>Personalisierung <span data-comment class="comment-info">Hintergründe, Live-Hintergründe, Startbildschirm, Sperrbildschirm, Klingeltöne</span></p>' },
                    { item: 'P', comment: '<p class="b-hover" data-id>Fotografie <span data-comment class="comment-info">Kameras, Bildbearbeitungstools, Fotoverwaltung und -weitergabe</span></p>' },
                    { item: 'Q', comment: '<p class="b-hover" data-id>Effizienz <span data-comment class="comment-info">Notepad, Aufgabenliste, Tastatur, Drucken, Kalender, Sicherung, Rechner, Konvertierung</span></p>' },
                    { item: 'L', comment: '<p class="b-hover" data-id>Shopping <span data-comment class="comment-info">Online-Shopping, Auktionen, Gutscheine, Preisvergleich, Einkaufszettel, Produktbewertungen</span></p>' },
                    { item: '1', comment: '<p class="b-hover" data-id>Soziale Netzwerke <span data-comment class="comment-info">Soziale Netzwerke, Check-in</span></p>' },
                    { item: '2', comment: '<p class="b-hover" data-id>Sport <span data-comment class="comment-info">Sportnachrichten und -kommentare, Spielstand, Fantasieteamzusammenstellung, Spielberichterstattung</span></p>' },
                    { item: '3', comment: '<p class="b-hover" data-id>Tools <span data-comment class="comment-info">Tools für Android-Geräte</span></p>' },
                    { item: '4', comment: '<p class="b-hover" data-id>Reisen & Lokales <span data-comment class="comment-info">Reisebuchungstools, Fahrgemeinschaften, Taxis, Stadtführer, Informationen zu lokalen Geschäften und Unternehmen, Reiseverwaltungstools, Reisebuchung</span></p>' },
                    { item: '5', comment: '<p class="b-hover" data-id>Videoplayer & Editors <span data-comment class="comment-info">Videoplayer, Video-Editor, Medienspeicher</span></p>' },
                    { item: '6', comment: '<p class="b-hover" data-id>Wetter <span data-comment class="comment-info"></span></p>' },
                    { item: '7', comment: '<p class="b-hover" data-id>Andere <span data-comment class="comment-info"></span></p>' }
                ],
                options5: [
                    { item: 'A', name: 'Einfachheit' },
                    { item: 'B', name: 'Geschwindigkeit' },
                    { item: 'C', name: 'Weniger Tastatureingabe, mehr Bildschirm-Interaktion' },
                    { item: 'D', name: 'Überzeugendes Benutzer-Feedback' },
                    { item: 'E', name: 'Verschiedene Versionen für verschiedene mobile Geräte' },
                    { item: 'F', name: 'Gute Bildauflösung' },
                    { item: 'H', name: 'Sicherheit' },
                    { item: 'J', name: 'Social Media Networking-Möglichkeiten' },
                    { item: 'K', name: 'Suchfunktion in mobiler Anwendung angezeigt' },
                    { item: 'O', name: 'Ausdrucksvolles Design, kräftige Farben' }
                ],
                options6: [
                    { item: 'A', name: 'Ein Angebot und einmalige Entwicklung zum Festpreis' },
                    { item: 'B', name: 'Agiles Projekt, gesamtes Entwickler-Team beim Dienstleister, Projektmanagement beim Auftraggeber ' },
                    { item: 'C', name: 'Outstaffing (Festanstellung von Entwicklern bei uns Projektdauer >12 Monate)' }

                ],
                options7: [
                    { item: 'A', name: 'Werbung' },
                    { item: 'B', name: 'In-App-Käufe' },
                    { item: 'C', name: 'kostenpflichtiger Download' },
                    { item: 'C', name: 'All4Free' }
                ],
                options8: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ],
                options9: [
                    { item: 'A', name: 'App Stores' },
                    { item: 'B', name: 'Nutzer erhält Link' }

                ],
                options10: [
                    { item: 'A', name: 'iOS' },
                    { item: 'B', name: 'Android' },
                    { item: 'C', name: 'Web' },
                ],
                options11: [
                    { item: 'A', name: 'Smartphones' },
                    { item: 'B', name: 'Tablets' },
                    { item: 'C', name: 'Desktop (PCs)' },
                ],
                options12: [
                    { item: 'A', name: '1' },
                    { item: 'B', name: '2' },
                    { item: 'C', name: '3' },
                    { item: 'D', name: '4' },
                    { item: 'E', name: '> 5' }
                ],
                options13: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ],
                options14: [
                    { item: 'A', name: 'GPS' },
                    { item: 'B', name: 'Mikrofon' },
                    { item: 'C', name: 'NFC' },
                    { item: 'D', name: 'Kamera' },
                    { item: 'E', name: 'Bluetooth' },
                    { item: 'F', name: 'Gyroskop-Sensor' },
                    { item: 'G', name: 'Fingerabdrucksensor' },
                    { item: 'H', name: 'Gesichtserkennung' },
                    { item: 'I', name: 'Beschleunigungsmesser' },
                    { item: 'K', name: 'Näherungssensor' },
                    { item: 'L', name: 'Lichtsensor' },
                    { item: 'M', name: 'Schrittmesser' },
                    { item: 'N', name: 'Pulsmesser' },
                    { item: 'O', name: 'Magnetomesser (digitaler Kompass)' }
                ],
                options15: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ]
            }
        },
        mounted() {
            this.$root.$on('company-story', (story) => {
                this.title = story.year;
                this.content = story.modal;
                this.$bvModal.show('story-modal')
            });
            if ( !this.$cookies.isKey('_accepted')){
                this.showModal();
            } else if (this.$cookies.get('_accepted')) {
                return;
            } else {
                this.showModal();
            }
            localStorage.clear();
        },
        computed: {
            get1cost() {
                // let total1 = 1;
                // let total2 = this.value;
                let total3 = 0;
                let total4 = 0;
                let total51 = 1;
                let total52 = 1;
                let total53 = 1;
                let total54 = 1;
                let total55 = 1;
                let total56 = 1;
                let total57 = 1;
                let total58 = 1;
                let total59 = 1;
                let total510 = 1;
                let total5 = 0;
                let total6 = 1;




                if (this.selected1 === 'A') {
                    localStorage.setItem('total1', 1.5);
                } else if ( this.selected1 === 'B') {
                    localStorage.setItem('total1', 1);
                } else if ( this.selected1 === 'C') {
                    localStorage.setItem('total1', 0.8);
                } else if ( this.selected1 === 'D') {
                    localStorage.setItem('total1', 0.5);
                }


                if (this.selected3 === 'A') {
                    total3 = 0.9;
                } else if ( this.selected3 === 'B') {
                    total3 = 1.1;
                } else if ( this.selected3 === 'C') {
                    total3 = 1.2;
                }

                if (this.selectedB2B === 'A') {
                    total4 = 16;
                } else if ( this.selectedB2B === 'B') {
                    total4 = 16;
                } else if ( this.selectedB2B === 'C') {
                    total4 = 16;
                } else if ( this.selectedB2B === 'D') {
                    total4 = 28;
                } else if ( this.selectedB2B === 'E') {
                    total4 = 8;
                } else if ( this.selectedB2B === 'F') {
                    total4 = 8;
                } else if ( this.selectedB2B === 'H') {
                    total4 = 12;
                } else if ( this.selectedB2B === 'J') {
                    total4 = 16;
                } else if ( this.selectedB2B === 'K') {
                    total4 = 8;
                } else if ( this.selectedB2B === 'O') {
                    total4 = 12;
                } else if ( this.selectedB2B === 'M') {
                    total4 = 24;
                } else if ( this.selectedB2B === 'N') {
                    total4 = 24;
                } else if ( this.selectedB2B === 'S') {
                    total4 = 10;
                } else if ( this.selectedB2B === 'T') {
                    total4 = 24;
                } else if ( this.selectedB2B === 'R') {
                    total4 = 36;
                } else if ( this.selectedB2B === 'Z') {
                    total4 = 9;
                } else if ( this.selectedB2B === 'X') {
                    total4 = 16;
                } else if ( this.selectedB2B === 'Y') {
                    total4 = 4;
                }


                if (this.selectedB2C === 'A') {
                    total4 = 16;
                } else if ( this.selectedB2C === 'B') {
                    total4 = 12;
                } else if ( this.selectedB2C === 'C') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'D') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'E') {
                    total4 = 16;
                }else if ( this.selectedB2C === 'F') {
                    total4 = 16;
                }else if ( this.selectedB2C === 'H') {
                    total4 = 8;
                }else if ( this.selectedB2C === 'J') {
                    total4 = 16;
                }else if ( this.selectedB2C === 'K') {
                    total4 = 20;
                }else if ( this.selectedB2C === 'O') {
                    total4 = 24;
                }else if ( this.selectedB2C === 'M') {
                    total4 = 8;
                }else if ( this.selectedB2C === 'N') {
                    total4 = 24;
                }else if ( this.selectedB2C === 'S') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'T') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'R') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'Z') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'X') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'Y') {
                    total4 = 20;
                }else if ( this.selectedB2C === 'W') {
                    total4 = 16;
                }else if ( this.selectedB2C === 'V') {
                    total4 = 24;
                }else if ( this.selectedB2C === 'I') {
                    total4 = 10;
                }else if ( this.selectedB2C === 'P') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'U') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'S') {
                    total4 = 24;
                }else if ( this.selectedB2C === 'P') {
                    total4 = 12;
                }else if ( this.selectedB2C === 'Q') {
                    total4 = 10;
                }else if ( this.selectedB2C === 'L') {
                    total4 = 16;
                }else if ( this.selectedB2C === '1') {
                    total4 = 12;
                }else if ( this.selectedB2C === '2') {
                    total4 = 16;
                }else if ( this.selectedB2C === '3') {
                    total4 = 12;
                }else if ( this.selectedB2C === '4') {
                    total4 = 12;
                }else if ( this.selectedB2C === '5') {
                    total4 = 2;
                }else if ( this.selectedB2C === '6') {
                    total4 = 2;
                } else if ( this.selectedB2C === '7') {
                    total4 = 8;
                }


                if (this.selected5.includes('A') ){
                    total51 = 1.2;
                }
                if ( this.selected5.includes( 'B') ){
                    total52 = 1.2;
                }
                if ( this.selected5.includes( 'C') ){
                    total53 = 1.2;
                }
                if ( this.selected5.includes( 'D') ){
                    total54 = 1.2;
                }
                if ( this.selected5.includes( 'E') ){
                    total55 = 1.2;
                }
                if ( this.selected5.includes( 'F') ){
                    total56 = 1.2;
                }
                if ( this.selected5.includes( 'H') ){
                    total57 = 1.5;
                }
                if ( this.selected5.includes( 'J') ){
                    total58 = 1.1;
                }
                if ( this.selected5.includes( 'K') ){
                    total59 = 1.1;
                }
                if ( this.selected5.includes( 'O') ){
                    total510 = 1;
                }
                this.selected5 ? total5 =  total51 * total52 * total53 * total54 * total55 * total56 * total57 * total58 * total59 * total510 : 0;

                if (this.selected6 === 'A') {
                    total6 = 1;
                } else if ( this.selected6 === 'B') {
                    total6 = 1.5;
                } else if ( this.selected6 === 'C') {
                    total6 = 0.75;
                }

                let get1cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (2 + (( this.isZero(total3) * this.isZero(total4)) + total5)) * total6);

                return get1cost;
            },
            get2cost () {
                // let total1 = 1;
                let total7 = 0;
                let total8 = 0;
                let total9 = 0;

                if (this.selected1 === 'A') {
                    localStorage.setItem('total1', 1.5);
                } else if ( this.selected1 === 'B') {
                    localStorage.setItem('total1', 1);
                } else if ( this.selected1 === 'C') {
                    localStorage.setItem('total1', 0.8);
                } else if ( this.selected1 === 'D') {
                    localStorage.setItem('total1', 0.5);
                }

                if (this.selected7 === 'A') {
                    total7 = 1.1;
                } else if ( this.selected7 === 'B') {
                    total7 = 1.2;
                } else if ( this.selected7 === 'C') {
                    total7 = 1.1;
                } else if ( this.selected7 === 'C') {
                    total7 = 1;
                }

                if (this.selected8 === 'A') {
                    total8 = 1.2;
                } else if ( this.selected8 === 'B') {
                    total8 = 1;
                }

                if (this.selected9 === 'A') {
                    total9 = 1.1;
                } else if ( this.selected9 === 'B') {
                    total9 = 1;
                }

                let get2cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (total7 + total8 + total9));
                return get2cost;
            },
            get3cost () {
                // let total1 = 1;
                let total10 = 1;
                let total101 = 0;
                let total102 = 0;
                let total103 = 0;
                let total111 = 0;
                let total112 = 0;
                let total113 = 0;
                let total11 = 1;
                let total12 = 0;
                let total13 = 0;
                let total14 = 0;
                let total15 = 0;
                let total141 = 1;
                let total142 = 1;
                let total143 = 1;
                let total144 = 1;
                let total145 = 1;
                let total146 = 1;
                let total147 = 1;
                let total148 = 1;
                let total149 = 1;
                let total1410 = 1;
                let total1411 = 1;
                let total1412 = 1;
                let total1413 = 1;
                let total1414 = 1;


                if (this.selected1 === 'A') {
                    localStorage.setItem('total1', 1.5);
                } else if ( this.selected1 === 'B') {
                    localStorage.setItem('total1', 1);
                } else if ( this.selected1 === 'C') {
                    localStorage.setItem('total1', 0.8);
                } else if ( this.selected1 === 'D') {
                    localStorage.setItem('total1', 0.5);
                }

                if (this.selected10.includes('A') ){
                    total101 = 1.5;
                }
                if ( this.selected10.includes( 'B') ){
                    total102 = 1.5;
                }
                if ( this.selected10.includes( 'C') ){
                    total103 = 1.5;
                }

                total10 += total101 + total102 + total103;

                if (this.selected11.includes('A') ){
                    total111 = 1.2;
                }
                if ( this.selected11.includes( 'B') ){
                    total112 = 1.2;
                }
                if ( this.selected11.includes( 'C') ){
                    total113 = 1.2;
                }

                total11 = total111 + total112 + total113;

                if (this.selected12 === 'A') {
                    total12 = 0;
                } else if ( this.selected12 === 'B') {
                    total12 = 1;
                } else if ( this.selected12 === 'C') {
                    total12 = 2;
                } else if ( this.selected12 === 'D') {
                    total12 = 2;
                } else if ( this.selected12 === 'E') {
                    total11 = 3;
                }




                if (this.selected13 === 'A') {
                    total13 = 0;
                } else if ( this.selected13 === 'B') {
                    total13 = 2;
                }

                if (this.selected14.includes('A') ){
                    total141 = 1.1;
                }
                if ( this.selected14.includes( 'B') ){
                    total142 = 1.1;
                }
                if ( this.selected14.includes( 'C') ){
                    total143 = 1.1;
                }
                if ( this.selected14.includes( 'D') ){
                    total144 = 1.1;
                }
                if ( this.selected14.includes( 'E') ){
                    total145 = 1.1;
                }
                if ( this.selected14.includes( 'F') ){
                    total146 = 1.1;
                }
                if ( this.selected14.includes( 'G') ){
                    total147 = 1.1;
                }
                if ( this.selected14.includes( 'H') ){
                    total148 = 1.1;
                }
                if ( this.selected14.includes( 'I') ){
                    total149 = 1.1;
                }
                if ( this.selected14.includes( 'K') ){
                    total1410 = 1.1;
                }
                if ( this.selected14.includes( 'L') ){
                    total1411 = 1.1;
                }
                if ( this.selected14.includes( 'M') ){
                    total1412 = 1.1;
                }
                if ( this.selected14.includes( 'N') ){
                    total1413 = 1.1;
                }
                if ( this.selected14.includes( 'O') ){
                    total1414 = 1.1;
                }
                this.selected14 ? total14 =  total141 * total142 * total143 * total144 * total145 * total146 * total147 * total148 * total149 * total1410 * total1411 * total1412 * total1413 * total1414 : 0;

                if (this.selected15 === 'A') {
                    total15 = 4;
                } else if ( this.selected15 === 'B') {
                    total15 = 0;
                }

                let get3cost = this.isZero(localStorage.getItem('total1')) * (1500 * (this.isZero(total12 + total13 + total14)) * this.isZero(total10) * this.isZero(total11) + 1500 * total15);
                console.log(total15);
                return Math.round(get3cost);
            }
        },
        methods: {
            submit () {
                this.loading = '#28a745';
                this.$httpService.post('api/v2/subscribe', this.form, {
                    headers:{
                        'X-Subscription-Type': 'appcalc',
                        'X-Redirect-URL': window.location.hostname + '/subscribed='
                    }
                })
                    .then(response => {
                        this.$root.$emit('alert', {type: 'success', message: response.data.message, show: true})
                        for (let k in this.form){
                            /* eslint-disable no-prototype-builtins */
                            this.form.hasOwnProperty(k) ? this.form[k] = null : null;
                        }
                    })
                    .finally( () => {
                        this.loading = false;
                    })
            },
            showModal() {
                this.$bvModal.show('my-modal')
            },
            acceptCookies() {
                this.$cookies.set('_accepted', true);
                this.$bvModal.hide('my-modal')
                localStorage.setItem('COOKIE', true);
                localStorage.setItem('GA', true);
            },
            step1 () {

                localStorage.setItem('selection3', JSON.stringify(this.selection3));
                console.log('da bklz')
            },
            changeCalView (){

                if ( this.selected3 === 'B') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log(document.getElementById('b2b'))
                } else if (this.selected3 === 'C') {
                    document.getElementById('b2c2').classList.add("clickedb2b");
                    document.getElementById('b2b2').classList.remove("clickedb2b");
                    console.log('C')
                } else if (this.selected3 === 'A') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log('A')
                }
            },
            isZero(value) {
                if (value === 0) {
                    return 1
                }
                return value;
            }
        }
    }
</script>


<style>

    @media screen and (max-width: 1100px) {
        .entry-text-cc {
            font-size: 1.12rem;
        }
        a {
            color: white!important;
        }

        html {
            scroll-behavior: smooth;
        }
        body {
            font-family: Poppins!important;
            scroll-behavior: smooth;
        }
        p {
            color: white;
        }
        .cc-intro {
            padding-top: 10%;
            display: inline-block;
            vertical-align: middle;
        }
        legend {
            font-family: Poppins;
            font-style: normal;
            font-weight: normal;
            font-size: 24px;
            color: #FFFFFF!important;
        }
        .page-container {
            background-color: #474747;
        }
        .page-paddings {
            padding-left: 5%;
            padding-right: 5%;
        }
        .page-paddings-left {
            padding-left: 5%;
        }

        .cc-button {
            background: #00FBAF!important;
            box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
            padding-right: 25px!important;
            padding-left: 25px!important;
            border-radius: 50px!important;
            font-family: Poppins;
            font-style: normal;
            font-weight: 700!important;
            font-size: 1.2rem;
            line-height: 133%;
            color: #474747!important;
        }
        .entry-tittle-main {
            width: 100%;
            background: linear-gradient( 90deg, #3079FF, #00FBAF);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #0B2349;
            font-size: 2.4rem;
            text-align: center;
            margin-top: -80px;
        }

        .entry-part-end {
            margin-bottom: 100px;
        }
        .cc-point-title {
            width: 100%;
            background: linear-gradient( 90deg, #3079FF, #00FBAF);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #0B2349;
            text-align: center;
            font-size: 1.2rem;
        }

        .cc-point-title-final {
            width: 100%;
            background: linear-gradient( 90deg, #3079FF, #00FBAF);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #0B2349;
            text-align: left;
            font-size: 1.2rem;
        }
        .cc-point-title-last {
            background: linear-gradient( 270deg, #3079FF, #00FBAF);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            color: #0B2349;
        }

        .row {
            margin-left: 0!important;
            margin-right: 0!important;
        }
        span {
            color: white;
        }
        .point-number {
            font-size: 1.4rem;
            font-weight: bold;
            line-height: 133%;
            color: #3079FF;
        }

        .point-container {
            padding-top: 10px;
            padding-bottom: 35px;
        }
        .point-name {
            font-family: Poppins;
            font-style: normal;
            font-weight: normal;
            font-size: 1.2rem;
            line-height: 133%;
            color: #FFFFFF;
            padding-top: 4px;
            padding-left: 10px;
            width: 90%;
        }

        .cc-questions-container {
            box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.09), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
            border-radius: 45px;
            padding: 5%;
            margin-top: 3%;
            margin-bottom: 8%;
        }

        .amount-text {
            font-family: Poppins;
            font-style: normal;
            font-weight: normal;
            font-size: 1.2rem;
            line-height: 133%;
            color: #FFFFFF;
            vertical-align: middle;
        }

        .amount-button {
            background: #474747!important;
            box-shadow: -10px -10px 25px rgba(255, 255, 255, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
            border-radius: 50px!important;
            width: 100%;
            font-family: Poppins;
            font-style: normal;
            font-weight:600!important;
            font-size: 1.2rem!important;
            line-height: 132%;
            color: #00FBAF!important;
            margin-top: 15%;
        }
        .amount-row {
            display: inline-flex;
            padding: 0!important;
        }
        hr {
            background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            height: 1px!important;
        }
        .semi-final-amount {
            font-family: Poppins;
            font-style: normal;
            font-weight: 500;
            font-size: 1rem;
            line-height: 133%;
            color: #FFFFFF;
        }
        .marketing-component {
            box-shadow: -10px -10px 25px rgba(0, 251, 175, 0.1), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;
            border-radius: 45px;
            font-size: 1rem;
        }
        .marketing-component-text{
            font-size: 1rem!important;
        }

        .site-footer {
            background: #323232;
            padding: 20px;
            margin-top: 50px;
        }

        .my-buttons .active {
            color: #fff !important;
            background-color: #28a745 !important;
            border-color: #28a745 !important;
        }
        input {
            /*background: linear-gradient( 90deg, #3079FF, #00FBAF)!important;*/
        }
        .d-grid {
            display: grid!important;
            padding-left: 33px;
        }

        .d-grid-40 {
            display: grid!important;
            padding-left: 40px;
        }
        .input-pad {
            padding-left: 17px;
        }

        .input-pad-big {
            padding-left: 25px;
        }
        input {
            background-color: #474747;
            /*border: #adb5bd solid 1px;*/
            box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4) !important;
            border: none!important;
            color: white!important;
        }
        .custom-control {
            padding-top: 15px;
            padding-bottom: 15px;}

        .custom-control-label::before {
            position: absolute;
            top: 0.25rem;
            left: -1.5rem;
            display: block;
            width: 1rem;
            height: 1rem;
            pointer-events: none;
            content: "";
            background: #474747!important;
            box-shadow: inset 0px 4px 15px rgba(0, 0, 0, 0.4)!important;
            border: none!important;
        }

        .custom-control-label::after {
            position: absolute;
            top: 0.25rem;
            left: -1.5rem;
            display: block;
            width: 1rem;
            height: 1rem;
            content: "";
            background: no-repeat 50% / 50% 50%;
        }

        .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
            background-image: url("../assets/chech.png") !important;
            width: 35px!important;
            height: 35px!important;
            left: -31px!important;
            top: -9px!important;
        }

        .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
            background-image: url("../assets/radio.png") !important;
        }

        .custom-range::-webkit-slider-thumb {
            background: transparent!important;
            background-color: transparent!important;
            width: 1rem!important;
            height: 1rem!important;
            margin-top: -0.25rem;
            background-image: url("../assets/radio.png") !important;
            border: 0;
            border-radius: 1rem;
            -webkit-transition: none!important;
            transition:none!important;
            -webkit-appearance: none;
            appearance: none;
        }
        .drop-highlighter {
            color: #00FBAF;
        }
        .drop-container {
            display: none;
        }
        .drop-container.clickedb2b {
            display: block!important;
        }
        #range-2 {
            background-color: transparent!important;
            box-shadow: none !important;
        }
        .comment-info {
            display: inline-block;
            visibility: hidden;
            transition: visibility .3s ease-in-out;
            position: absolute;
            top: -50%;
            background: #474747;
            box-shadow: -15px -15px 35px rgba(255, 255, 255, 0.03), 10px 10px 25px rgba(0, 0, 0, 0.3) !important;;
            border-radius: 30px;
            padding: 35px;
            width: 40vw;
            z-index: 200;
        }

        .comment-info.visible {
            visibility: visible;
        }

        .b-hover:hover {
            color: #00FBAF;
        }
        .form-control  {
            background: #474747!important;
        }

        .vue-slider-dot-tooltip-text {
            color: #00FBAF!important;
            font-size: 1.4rem!important;
        }
        .route-mobile {
            background: #474747!important;
            box-shadow: -15px -15px 25px rgba(255, 255, 255, 0.03)!important;
            border-radius: 20px!important;
            font-weight: bold!important;
            font-size: 14px!important;
            line-height: 133%;
            text-align: center;
            color: #FFFFFF!important;
            padding-left: 15px;
            padding-right: 15px;
        }
        .route-mobile:active {
            background: #00FBAF!important;
        }
        .route-mobile:visited{
            border: 1px solid #00FBAF!important;
        }
        a {
            color: #FFFFFF!important;
        }

    }
    @media screen and (min-width: 576px) {

    }

</style>
